// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wapSate>div[data-v-15b6dfe4],.wapSate>span[data-v-15b6dfe4]{flex-shrink:0}", ""]);
// Exports
module.exports = exports;
